import { IApplicationState } from '../../types/redux';
import { getNewBuildings } from './getNewBuildings';

export function getNewbuildingsJsonQuery(state: IApplicationState) {
  const newbuildings = getNewBuildings(state);

  return newbuildings.jsonQuery;
}
